import { Controller } from "@hotwired/stimulus";
import StimulusReflex from "stimulus_reflex";

export default class extends Controller {
  static targets = ["input", "results", "selectedId"];

  connect() {
    StimulusReflex.register(this);
    console.log("OrganizationLocationSearchController connected");
  }

  search() {
    const query = this.inputTarget.value.trim();
    if (query.length < 2) {
      this.resultsTarget.classList.add("hidden");
      return;
    }

    // Set the query in the dataset for the reflex to access
    this.element.dataset.query = query;

    // Trigger the reflex
    this.stimulate("OrganizationLocationSearch#search");
  }

  // Reflex lifecycle methods
  beforeSearch() {
    this.resultsTarget.classList.add("opacity-50");
  }

  searchSuccess() {
    this.resultsTarget.classList.remove("opacity-50");
    this.resultsTarget.classList.remove("hidden");
  }

  searchError(error) {
    console.error("Organization location search error:", error);
    this.resultsTarget.classList.remove("opacity-50");
    this.resultsTarget.classList.add("hidden");
  }

  select(event) {
    console.log("OrganizationLocationSearchController#select called");
    const locationId = event.currentTarget.dataset.locationId;
    const locationName = event.currentTarget.dataset.locationName;

    this.selectedIdTarget.value = locationId;
    this.inputTarget.value = locationName;
    this.resultsTarget.classList.add("hidden");

    // Trigger change event for form validation
    this.inputTarget.dispatchEvent(new Event("change"));
  }
}
